import React, { useState, useEffect } from "react";
import md5 from "md5";
import Cookies from "universal-cookie";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "../css/Login.css";

function Login() {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const cookies = new Cookies();
  const navigate = useNavigate();

  const [form, setForm] = useState({ usuario: "", contrasena: "" });
  const [loading, setLoading] = useState(false);


  //Obtener valores de los Input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  //Metodo para inicar sesion
  const iniciarSesion = async () => {
    if (!form.usuario || !form.contrasena) {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Por favor, completa todos los campos.",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(
        `${baseURL}/api/Usuarios/${form.usuario}/${md5(form.contrasena)}`
      );
      const data = response.data;

      if (data.length > 0) {
        const usuario = data[0];
        cookies.set("idUsuario", usuario.idUsuario, { path: "/" });
        cookies.set("nombreUsuario", usuario.nombreUsuario, { path: "/" });
        cookies.set("nombre", usuario.nombre, { path: "/" });
        cookies.set("apellido", usuario.apellido, { path: "/" });
        cookies.set("correo", usuario.correo, { path: "/" });
        cookies.set("estado", usuario.estado, { path: "/" });
        cookies.set("rol", usuario.rol, { path: "/" });

        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Inicio de sesión exitoso",
          showConfirmButton: false,
          timer: 3000,
        });

        navigate("/inicio");
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El usuario o contraseña son incorrectos.",
        });
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      Swal.fire({
        icon: "error",
        title: "Error de conexión",
        text: "Ocurrió un error al intentar iniciar sesión. Intenta más tarde.",
      });
    } finally {
      setLoading(false);
    }
  };

  //Iniciar
  useEffect(() => {
    if (cookies.get("idUsuario")) {
      navigate("/inicio");
    }
  }, []);


  //Codigo Html
  return (
  <div className="login-bg d-flex justify-content-center align-items-center vh-100">
    <div className="login-box card shadow-lg p-4">
      <div className="text-center mb-4">
        <img
          src="https://i.ibb.co/rGr0HKNN/logo2.png"
          alt="TuRips Logo"
          style={{ width: "80px" }}
        />
        <h3 className="mt-3">Iniciar sesión</h3>
      </div>
      <div>
        <div className="mb-3">
          <label className="form-label">Usuario</label>
          <input
            type="text"
            name="usuario"
            className="form-control"
            placeholder="Ingrese su usuario"
            autoComplete="off"
            maxLength={20}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Contraseña</label>
          <input
            type="password"
            name="contrasena"
            className="form-control"
            placeholder="Ingrese su contraseña"
            autoComplete="off"
            maxLength={20}
            onChange={handleChange}
          />
        </div>
        <button
          type="button"
          className="btn btn-primary w-100"
          onClick={iniciarSesion}
          disabled={loading}
        >
          {loading ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            "Entrar"
          )}
        </button>
      </div>
      <footer className="text-center mt-4 text-muted small">
        &copy; 2025 TuRips. Todos los derechos reservados.
      </footer>
    </div>

    {/* NUEVO TEXTO INFERIOR DERECHA */}
    <div className="login-footer-brand">
      <strong>TuRips</strong><br />
      Sistema RIPS JSON para gestión y control
    </div>
  </div>
);


}

export default Login;
